import { LogEntry } from '@/parsing/LogEntry';

import { TimelineMarker, TimelineRow } from '../TimelineData';
import { TimelineGeneratorContext } from './TimelineGeneratorContext';

export function addTimeSpanMarker(args: {
  startEntry: LogEntry;
  endEntry: LogEntry | undefined;
  endTimeMs: number;
  row: TimelineRow;
  ctx: TimelineGeneratorContext;
  fillColor: string;
  textOnMarker: string;
  textOnMarkerColor: string;
  tooltipContent: string;
}) {
  const startTimeMs = args.startEntry.date.getTime();
  const spanMs = args.endTimeMs - startTimeMs;
  const spanSec = spanMs / 1000.0;
  let spanStr = '';
  if (spanSec < 1.0) {
    spanStr = `${Math.round(spanMs)}ms`;
  } else if (spanSec < 5.0) {
    spanStr = `${spanSec.toFixed(2)}s`;
  } else {
    const min = Math.floor(spanSec / 60);
    const sec = Math.round(spanSec - min * 60);
    if (min < 0.01) {
      spanStr = `${sec}s`;
    } else {
      spanStr = `${min}m ${sec}s`;
    }
  }

  const marker: TimelineMarker = {
    markerId: args.ctx.nextMarkerId,
    logEntry: args.startEntry,
    alternativeLogEntry: args.endEntry,
    startTimeMs,
    endTimeMs: args.endTimeMs,
    fillColor: args.fillColor,
    textOnMarker: `${args.textOnMarker} (${spanStr})`,
    textOnMarkerColor: args.textOnMarkerColor,
    tooltipContent: `${args.tooltipContent} (${spanStr})`,
  };
  args.ctx.nextMarkerId += 1;

  args.row.markers.push(marker);
}
